import React = require('react');
import { OptionsDisplay } from '../../../../../../../Components/OptionsDisplay';
import { useState } from 'react';

interface IMTAOptionDetailProps {
  options: any[];
  noPadding?: boolean;
}

export const MTAOptionDetails = ({ options, noPadding }: IMTAOptionDetailProps) => {

  const [showDetails, setShowDetails] = useState(false);

  const handleOnClick = () => {
    setShowDetails(!showDetails)
  }
  const optionNames = [
    'Winter Sports',
    'Cruise Cover',
    'Excess Waiver',
    'Gadget Cover',
    'Hazardous Activities',
    'Enhanced Trip Disruption Cover'
  ];

  return (
    <div className={'details-overview'}>
      <div className={noPadding ? 'details-overview-header no_padding' : 'details-overview-header'} style={{ cursor: 'pointer' }} onClick={handleOnClick}>
        <div className={'d-overview-icon'}>
          <img src={require('../../../../../../Images/add-button.svg')} width={'45px'} alt={''}/>
        </div>
        <div className={'d-overview-text'}>Additional Cover</div>
        <div className={'d-overview-dropdown-icon'}>
          <img src={require('../../../../../../Images/arrow-down-sign-to-navigate.svg')} width={'45px'} alt={''}/>
        </div>
      </div>

      {showDetails && (
        <>
          {optionNames.map((names, index) => {
            return (
              <div className={'details-overview-row'} key={index}>
                <div className={'d-o-attribute'}>
                  <div><OptionsDisplay options={options} optionName={names}/></div>
                </div>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}
